import { UserMissionPage } from './UserMissionPage'
import { withUserMissionPage } from './withUserMissionPage'

const Connected = withUserMissionPage(UserMissionPage)

export { Connected as UserMissionPage }
